// **** import modules ****
import $ from "jquery";
import app, { u_, vuwer, csl } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";
import popupLayaway from "./_layaway";

// **** process ****
vuwer.add("productsSection", {
	selector: "#products_section"
}, function() {
	const dataKey = "products";
	
	// [add child vuw]
	this
	// define [postList]
	.add("productList", {
		vuwType: "colony",
		selector: "#data_list_products",
		
		// ** for TyrellModule **
		module: {
			app,
			dataKey,
/*
			// 取得条件
			getFilter: {
				// 取得項目（未指定や空の配列の場合は全て取得）
				getParams: [],
				// 除外項目
				kickParams: [],
				// 取得条件 ※SQLのWHEREに相当
				conditions: [
					{
						"targetParam": "category",
						"condition": "not",	// [gt, gte, eq, lt, lte, not, in]
						"value": "event"
					}
				]
			},
			
			// 一覧データの日付によるグループ分けのキー（年月ごとのグループ分け）※未指定の場合は"dateUpd"
			pkGroupByDate: "dateUpd",
			
			// 一覧データの日付によるグループ分けのフォーマット ※未指定の場合は"YYYY-MM"
			byDateFormat: "YYYY-MM",
*/
			
			// データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
			itemFilter(i, item) {
				u_.isObject(this.items.byCategory) || (this.items.byCategory = {});
				if( !Array.isArray(this.items.byCategory[item.category]) ) {
					this.items.byCategory[item.category] = [];
				}
				this.items.byCategory[item.category].push(item);
			},
			
			// 設定情報の上書き
			configOverride: {
				pageLimit: 40,
				// NEWマークを付ける期間
				periodNew: app.now.subtract(2, "days")
			}
		},
		
		// ** for VuwColony **
		// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
		articleTemplate: "",
		
		// ページャーの表示・非表示
		showPager: false,
		
		/*----------------
		* 記事表示用の関数（未指定の場合はテンプレートから生成）
		* @param item [object] １記事分のデータオブジェクト
		* @param config [object] 設定オブジェクト
		* @param $artcl [$] テンプレートから生成された$オブジェクト
		* @param module [TyrellModule] データ取得用モジュール
		* @return (falseを返すと非表示)
		*/
		initArticle(item, config, $article, module) {
			
			// Swiper用のclassを追加
			const $eyecatch = $article.find(".eyecatch");
			$eyecatch.children(".echoed-data").addClass("swiper-slide");

			// Swiperのナビゲーションを削除
			if(item.mainImage && item.mainImage.length < 2) {
				const $elmSwiper = $article.children(".swiper-container");
				$elmSwiper.children(".swiper-button-next").remove();
				$elmSwiper.children(".swiper-button-prev").remove();
			}
			
			// Swiperを削除
			if(!item.mainImage) {
				const $elmSwipercontainer = $article.children(".swiper-container");
				$elmSwipercontainer.removeClass("swiper-container");
				$elmSwipercontainer.children(".swiper-pagination").remove();
				$elmSwipercontainer.children(".swiper-button-next").remove();
				$elmSwipercontainer.children(".swiper-button-prev").remove();
			}
			
			// NEW
			if(!config.periodNew.isAfter(item.dateIssue, "day")) {
				$article.addClass("is-new");
			}
			
			//価格ラベル
			const $priceState = $article.find(".meta > .priceState");
			csl.log("$priceState", $priceState);
			if($priceState.children("span").length === 0) {
				$priceState.addClass("is-disable");
			}
			
			// 金額
			const $amount = $article.find(".meta > .price > .echoed-data");
			if( $amount.text() ) {
				const number = $amount.text().replace("円", '');
				const numberWithComma = new Intl.NumberFormat();
				const price = numberWithComma.format(number);
				const $unit = $("<span/>").addClass("unit").text("円");
				const $localeAmount = $("<span/>").addClass("echoed-data type-number").attr({"data-key": "price"}).text(price).append($unit);
				$amount.replaceWith($localeAmount);
			}

			// 取り置きボタンの制御
			const $button = $article.find(".meta > .info > .order");
			$button.val(item.itemId);
			
			csl.log('item - ', item);
			
			if(item.orderList.length) {
				if(item.total >= item.stock) {
					// 品切れ
					$button.addClass("sold-out");
					$button.children("span").text("品切れ");
				} else {
					if(item.layawayTotal > 0) {
						// 取り置き中
						$button.addClass("layaway");
						$button.children("span").text("取り置き中");
					}
				}
			}
			
			if(!item.isAvailable) {
				$button.removeClass("layaway");
				$button.addClass("sold-out");
				$button.children("span").text("品切れ");
			}
			
			// 詳細ボタンの制御
			const $description = $article.find(".meta > .text > p");
			if( !$description.text() ) {
				$article.find(".meta > .info > .description").addClass("disable");
			}
		},
		
		onReady($self) {
			$self.on('click', '.order', e => {
				e.preventDefault();
				if($(e.currentTarget).hasClass("sold-out") || $(e.currentTarget).hasClass("layaway")) {
					return false;
				}
				
				const { value } = e.currentTarget;

				let item = {};
				if(value) {
					item = this.module.items.byId[value];
				}

				let fileName = "./assets/images/noImage.png";
				if(item.mainImage) {
					fileName = app.products.config.fileDir + "/img/mainImage" + item.itemId + "_1." + item.mainImage[0].ext;
				}

				popupLayaway(`
					<div class="confirm-body">
						<div class="product">
							<div class="thumb">
								<img src="${fileName}">
							</div>
							<div class="info">
								<p class="code">商品コード：${item.itemId}</p>
								<p class="name">${item.name}</p>
							</div>
						</div>
					</div>
					<button class="btn-submit hover-target" value="${item.itemId}">取り置きを確定</button>
				`.replace(/\t|\n/g, ""));
			});
			
			$self.on('click', '.description', e => {
				e.preventDefault();
				if( $(e.currentTarget).hasClass("disable") ) {
					return false;
				}
				csl.log("description - ", $(e.currentTarget).parent().parent());
				
				$(e.currentTarget).parent().parent().children(".text").toggleClass("visible");
			});
			
		},
		
		async onReadyLast($self) {
			if($self) {
				this.$btnMore = $self.next(".btns").children(".btn-more").addClass("is-disable");
				
				await this.initList(this.module.items.list);
				
				if(this.module.items.list.length) {
					this.$btnMore.removeClass("is-disable");
				}
			}
		}
	}, function() {
		// appから直接アクセス可能にする
		app[dataKey] = this.module;
	});
});
